import { render, staticRenderFns } from "./staffMoreNew.vue?vue&type=template&id=0d392dbe&scoped=true&"
import script from "./staffMoreNew.vue?vue&type=script&lang=js&"
export * from "./staffMoreNew.vue?vue&type=script&lang=js&"
import style0 from "./staffMoreNew.vue?vue&type=style&index=0&id=0d392dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d392dbe",
  null
  
)

export default component.exports